import Ajax from '../../../../util/ajax';
export function zigbeeNodeSave(nid, payload) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch, false);
        const url = '/zigbee/' + nid;
        ajax.post(url, payload);
    };
}
